import { Outlet } from 'react-router'
import { observer } from 'mobx-react-lite'
import { ChatbotAnalyticProvider } from 'pages/chatbot/pages/chatbotAnalytic/context/chatbotAnalyticContext'

export const ChatbotAnalyticLayout = observer(() => {
  return (
    <ChatbotAnalyticProvider>
      <Outlet />
    </ChatbotAnalyticProvider>
  )
})
